import React from 'react'
import {
  HeaderLogo,
  ProgressBar
} from 'belle-js'
import styles from './LoadingPage.module.scss'

const LoadingPage = () => (
  <div className={styles.loadingContainer}>
    <div className={styles.loadingPageContent}>
      <div className={styles.headerLogoContainer}>
        <div className={styles.logo}>
          <HeaderLogo size={55} />
        </div>

        <h3>Private Wealth</h3>
      </div>

      <div className={styles.bodyContainer}>
        <h1>Welcome to Ellevest</h1>
        <h2>Just a moment while we load your information</h2>
      </div>

      <div className={styles.loadingBarContainer}>
        <ProgressBar totalValue={100} currentValue={100} />
      </div>
    </div>
  </div>
)

export default LoadingPage



// WEBPACK FOOTER //
// ./src/components/Client/LoadingPage/LoadingPage.jsx